import { Trans, useTranslation } from 'react-i18next'
import type { GtmDemoController } from '@/features/gtm/domain/use-gtm-demo'
import { GtmUrlForm } from '@/features/gtm/components/gtm-url-form'
import { gtmMarker } from '@/features/gtm/components/gtm-marker'

type GtmHeroProps = {
  demo: GtmDemoController
}

export function GtmHero({ demo }: GtmHeroProps) {
  const { t } = useTranslation('gtm')

  return (
    <section className="mx-auto max-w-3xl space-y-6 pt-12 pb-6 text-center motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-3 motion-safe:duration-700 sm:space-y-8 sm:pt-20 sm:pb-10">
      <div className="space-y-4">
        {/* The h1 names the category for search and AI agents; the slogan
            below stays the biggest line people see. */}
        <h1 className="font-mono text-xs font-medium tracking-[0.18em] text-muted-foreground uppercase sm:text-sm">
          {t('heroKicker')}
        </h1>
        <p className="font-display text-4xl font-medium tracking-[-0.015em] text-balance text-foreground sm:text-5xl lg:text-6xl lg:leading-[1.05]">
          <Trans
            t={t}
            i18nKey="heroHeadline"
            components={{ accent: gtmMarker }}
          />
        </p>
        <p className="mx-auto max-w-2xl text-base leading-7 text-muted-foreground sm:text-lg sm:leading-8">
          <Trans
            t={t}
            i18nKey="heroSubtitle"
            components={{
              strong: <strong className="font-medium text-foreground" />,
            }}
          />
        </p>
      </div>
      <div className="mx-auto max-w-2xl text-left">
        <GtmUrlForm
          url={demo.url}
          onUrlChange={demo.setUrl}
          onSubmit={() => void demo.submit()}
          isBusy={demo.isSubmitting || demo.view.phase === 'running'}
          errorKey={demo.view.phase === 'failed' ? demo.view.errorKey : null}
        />
      </div>
    </section>
  )
}
